import { action, flow, makeObservable, observable } from "mobx";
import { API } from "aws-amplify";
import {getNotes, putNotes} from "../../graphql/queries";
// import { getUsers } from "../../graphql/queries"; // Commented out - GraphQL removed


class NotesStore {
  notes = [];
  categories = [];
  isLoading = false;
  isSuccessful = false;
  isError = false;
  isNotesDrawerOpen = false;
  selectedNote = {};

  constructor() {
    makeObservable(this, {
      notes: observable,
      isLoading: observable,
      isSuccessful: observable,
      isError: observable,
      isNotesDrawerOpen: observable,
      selectedNote: observable,
      categories: observable,
      openNotesDrawer: action,
      closeNotesDrawer: action,
      setCategories: action,
      setSelectedNote: action,
      setIsSuccessful: action,
      fetchNotesUCP: flow,
      updateNotes: flow,
      fetchUserData: flow,
    });
  }

  openNotesDrawer() {
    this.isNotesDrawerOpen = true;
  }

  closeNotesDrawer() {
    this.isNotesDrawerOpen = false;
    this.selectedNote = null;
  }

  setCategories(categories) {
    this.categories = categories;
  }

  setSelectedNote(note) {
    this.selectedNote = note;
  }

  *fetchNotesUCP(owner, noted) {
    try {
      this.isLoading = true;

      // GraphQL removed - commented out
      // const response = yield API.graphql({
      //   query: getNotes,
      //   variables: {
      //     input: {
      //       owner: owner,
      //       noted: noted,
      //     },
      //   },
      //   authMode: "AMAZON_COGNITO_USER_POOLS",
      // });
      const response = { data: { getNotes: { body: JSON.stringify([]) } } };

      this.notes = JSON.parse(response.data?.getNotes?.body);

    } catch (error) {
      this.isError = true;
    } finally {
      this.isLoading = false;
    }
  }

  setIsSuccessful() {
    this.isSuccessful = false;
  }

  *updateNotes(note) {
    this.isSuccessful = false;

    try {
      const data = {
        id: note.id || "",
        category: note.category,
        tags: [],
        metadata: JSON.stringify({}),
        owner: note.owner,
        noted: note.noted,
        memos: note.memos
      };

      // GraphQL removed - commented out
      // yield API.graphql({
      //   query: putNotes,
      //   variables: {
      //     input:data
      //   },
      //   authMode: 'AMAZON_COGNITO_USER_POOLS'
      // });

      // this.isSuccessful = true;

    } catch (error) {
      this.isError = true;
    }
  }

  *fetchUserData(userId, customer) {
    try {
      // GraphQL removed - commented out
      // const response = yield API.graphql({
      //   query: getUsers,
      //   variables: { input: { id: userId, customer } },
      //   authMode: "AMAZON_COGNITO_USER_POOLS",
      // });

      // const userData = JSON.parse(response.data?.getUsers?.body);

      // return {
      //   firstName: userData.first_name,
      //   lastName: userData.last_name,
      // }
      // TODO: Replace with REST API call
      return {
        firstName: '',
        lastName: '',
      }
    } catch (error) {
      this.isError = true;
    }
  }
}

export default NotesStore;
